import HASHES from "@/lib/assetHashes.json";

// Les ressources de public/ sont servies par le backend sous une URL versionnée,
// seule voie permettant un cache navigateur d'un an en production.
export function asset(url) {
  if (!url || !url.startsWith("/")) return url;
  const [path, query = ""] = url.split("?");
  const hash = HASHES[path];
  if (!hash) return url;
  return `/api/assets/${hash}${path}${query ? `?${query}` : ""}`;
}

// Transforme un srcSet complet ("/a.webp 480w, /b.webp 900w").
export function assetSet(srcSet) {
  if (!srcSet) return srcSet;
  return srcSet
    .split(",")
    .map((part) => {
      const [url, ...rest] = part.trim().split(/\s+/);
      return [asset(url), ...rest].join(" ");
    })
    .join(", ");
}
